import { useMemo } from "react";
import { useQuery } from "@apollo/client/react";

import { WorkspaceTombstoneDocument } from "#app/lib/data";

/**
 * What a purged workspace left at `urlPath` — null while the slug names
 * nothing the account can see or nothing that was ever deleted. Skipped
 * without a slug.
 */
export function useWorkspaceTombstone(urlPath: string | undefined) {
  const variables = useMemo(() => ({ urlPath: urlPath ?? "" }), [urlPath]);
  const { data } = useQuery(WorkspaceTombstoneDocument, {
    variables,
    skip: !urlPath,
  });
  return data?.workspaceTombstone ?? null;
}
